import { render, staticRenderFns } from "./kfixedgrid.vue?vue&type=template&id=582625ab&scoped=true"
import script from "./kfixedgrid.vue?vue&type=script&lang=js"
export * from "./kfixedgrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582625ab",
  null
  
)

export default component.exports